export const DEFAULT_CONVERSATION_NAME = 'New Chat';

/** Placeholder sidebar title for agent threads before title generation completes. */
export const DEFAULT_AGENT_CHAT_TITLE = 'New Agent Chat';

/** Backend placeholder while a voice session is waiting for title generation. */
export const DEFAULT_VOICE_CALL_TITLE = 'Voice call';

/** Agents v2 default chat agent — implicit responder for main chat (not a catalogue agent). */
export const DEFAULT_MAIN_CHAT_AGENT_ID = '000000000000000000000000';

export const isDefaultMainChatAgentId = (agentId?: string | null): boolean =>
  agentId === DEFAULT_MAIN_CHAT_AGENT_ID;

/** Catalogue agents selected from the agents UI; excludes the implicit main-chat default agent. */
export const isCatalogueAgentId = (agentId?: string | null): boolean =>
  !!agentId && !isDefaultMainChatAgentId(agentId);

/** Socket payload reason when the client reconnects during an active assistant stream */
export const NEW_CONNECTION_WHILE_STREAMING = 'NEW_CONNECTION_WHILE_STREAMING';

/** Stream inactivity window: reset on every received frame; on expiry the
 * stall watchdog reconciles against the server before surfacing an error. */
export const ASSISTANT_STREAM_TIMEOUT_MS = 120_000;

/** Sidebar, invite, and create-group entry points. */
export { isGroupChatEnabled as GROUP_CHAT_UI_ENABLED } from 'config/feature-flags';
